export class GuruAllowable {

  Value!: string;
  Description!: string;
  IsValid!: boolean;

}
